import { Component, OnInit, ViewChild } from '@angular/core';
import { IonContent } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { FileService } from 'src/app/services/file.service';
import { FormServices } from 'src/app/services/form-services.service';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-suggestions-chat',
  templateUrl: './suggestions-chat.page.html',
  styleUrls: ['./suggestions-chat.page.scss'],
})
export class SuggestionsChatPage implements OnInit {
  @ViewChild('ionContent') ionContent: IonContent;
  buttons = [
    {
      value: 'suggestion',
      name: 'Chat',
    },
    {
      value: 'suggestionOption',
      name: 'Opciones',
    },
    {
      value: 'messages',
      name: 'Mensajes',
    },
  ];

  fieldForms: any;
  domainId = environment.domainId;
  isUploading = false;
  savedForm: any;
  id = undefined;
  selected = 'suggestion';

  constructor(
    private formSv: FormServices,
    private httpSv: HttpService,
    private uiSv: UiServices,
    private fileSv: FileService,
    private trSv: TranslateService
  ) {}

  ngOnInit() {
    this.getForm();
  }

  async getForm() {
    try {
      const res = await this.formSv.getForm(this.selected, this.domainId);
      this.fieldForms = res;
    } catch (err) {
      console.error(err);
    }
  }

  changedValue(ev) {
    this.selected = ev;
    this.fieldForms = undefined;
    this.savedForm = undefined;
    this.id = undefined;
    setTimeout(async () => {
      await this.getForm();
    }, 500);
  }

  async sendInfo(ev: FormData) {
    try {
      this.id && ev.set('id', String(this.id));
      this.isUploading = true;
      const res: any = await this.httpSv.itemAction(
        ev,
        this.selected,
        this.id ? 'update' : 'store'
      );
      this.isUploading = false;
      const tr = this.trSv.instant('Guardado exitosamente');
      await this.uiSv.showToast(tr);
      if (res.status) {
        // this.id = res.data.id;
        this.savedForm = undefined;
        this.id = undefined;
        this.formSv.clearFormSrc.next();
        this.formSv.deleteListProductSrc.next('reloadListProduct');
        await this.getForm();
      }
    } catch (err) {
      console.error(err);
    }
  }

  async getCategories({ product, action, changeAction }) {
    try {
      product.suggestName = '';
      const { id, savedForm } = await this.fileSv.getProduct(
        { product, action, changeAction },
        this.id,
        this.selected,
        'Sugerencia',
        this.savedForm
      );
      this.id = id;
      this.savedForm = savedForm;
    } catch (err) {
      await this.uiSv.loading?.dismiss();
    }
  }

  async scrollToTop() {
    await this.ionContent.scrollToTop(400);
  }
}
